"use client";

import { Button } from "@/components/button";
import { RiFileCopyLine, RiCheckLine } from "@remixicon/react";
import { useState } from "react";
import { larissaChain } from "@/configs/chain";
import {mainConfig} from "@/configs/main.config";

interface RPCField {
  label: string;
  value: string;
}

export function RPCDetails() {
  const [copied, setCopied] = useState<string | null>(null);

  const rpcDetails: RPCField[] = [
    { label: "Network Name", value: larissaChain.name },
    { label: "RPC URL", value: larissaChain.rpcUrls.default.http[0] },
    { label: "Chain ID", value: larissaChain.id.toString() },
    { label: "Currency Symbol", value: larissaChain.nativeCurrency.symbol },
    { label: "Block Explorer URL", value: larissaChain.blockExplorers.default.url },
  ];

  const handleCopy = (value: string) => {
    navigator.clipboard.writeText(value).then();
    setCopied(value);
    setTimeout(() => setCopied(null), 2000);
  };

  const handleAddToMetaMask = () => {
    // This would be implemented with actual MetaMask integration
    if (typeof window !== 'undefined' && window.ethereum) {
      window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: mainConfig.chainHexID,
          chainName: larissaChain.name,
          nativeCurrency: {
            name: larissaChain.nativeCurrency.name,
            symbol: larissaChain.nativeCurrency.symbol,
            decimals: larissaChain.nativeCurrency.decimals,
          },
          rpcUrls: larissaChain.rpcUrls.default.http,
          blockExplorerUrls: [larissaChain.blockExplorers.default.url],
        }]
      })
      .then(() => alert('Larissa Network has been added to MetaMask'))
      .catch((error: Error) => alert(`Error: ${error.message}`));
    } else {
      alert('MetaMask is not installed. Please install MetaMask to add this network.');
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        {rpcDetails.map((field) => (
          <div key={field.label} className="flex flex-col sm:flex-row sm:items-center justify-between p-3 rounded-md bg-muted/10 border border-border">
            <div className="font-medium mb-2 sm:mb-0">{field.label}</div>
            <div className="flex items-center">
              <code className="px-2 py-1 bg-muted/20 rounded mr-2 text-sm">{field.value}</code>
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => handleCopy(field.value)}
              >
                {copied === field.value ? (
                  <RiCheckLine className="h-4 w-4 text-green-500" />
                ) : (
                  <RiFileCopyLine className="h-4 w-4" />
                )}
              </Button>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-6">
        <Button
          className="bg-white text-black hover:bg-[#FF8A3C]/10 border border-[#FF8A3C] transition-colors"
          onClick={handleAddToMetaMask}
        >
          Add Larissa Network to MetaMask
        </Button>
      </div>

      <div className="mt-6 p-4 bg-muted/20 rounded-md">
        <h3 className="font-medium mb-2">Connection Instructions</h3>
        <ol className="list-decimal pl-5 space-y-2 text-sm text-muted-foreground">
          <li>Open your wallet (MetaMask, Trust Wallet, etc.)</li>
          <li>Go to Settings &gt; Networks &gt; Add Network</li>
          <li>Enter the network details above</li>
          <li>Save the network configuration</li>
          <li>Switch to Larissa Network</li>
        </ol>
      </div>
    </div>
  );
}
